import {AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '@app/app/authentication/authentication.service';
import {DeviceService, EventTrackerService} from '@app/core';
import {AppParametersService} from '@app/core/token/app-parameters.service';
import {TokenService} from '@app/core/token/token.service';
import {CheckHtml5Service} from '@app/helper/check-html5.service';
import {IndicatorService} from '@app/shared';
import {environment} from '@env/environment';

import {SubscriptionService} from '../subscription/subscription.service';
import {SubscriptionStatus, SubscriptionStatusEnum} from '../subscription/subscriptionStatusResponse';
import {UserService} from './user-service.service';
import {PlayerService} from "@app/components/player/player.service";
import {ClientTypeEnum} from "@app/helper/ClientTypeEnum";
import {GoftinoService} from "@app/core/goftino.service";
import {DOCUMENT} from "@angular/common";

@Component({
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent implements OnInit, AfterViewInit {
  @ViewChild('unread_count_message_goftino', { static: false,  read: ElementRef}) private countGoftinoEl: ElementRef<HTMLSpanElement>;
  public userName: string;
  public userId: string;
  public mobileNo: string;
  public appVersion: string;
  public remainingTimeSubscription: number | null = null;
  public subscriptionStatus: SubscriptionStatusEnum;
  public SubscriptionStatusEnum: typeof SubscriptionStatusEnum = SubscriptionStatusEnum;
  public showCreditCode: boolean = false;
  public supportsCanvas: boolean;
  public supportVideo: boolean;
  public showIcon: boolean = true;
  public showAboutMenu: boolean;
  public clientType: typeof ClientTypeEnum = ClientTypeEnum;
  public isLogin: boolean = false;
  public environment: typeof environment = environment;
  public styleChevron = {
    width: "10px",
    height: "10px",
  };

  constructor(
    private readonly auth: AuthenticationService,
    public readonly parametersService: AppParametersService,
    public readonly tokenService: TokenService,
    private readonly subscriptionService: SubscriptionService,
    public readonly indicator: IndicatorService,
    private readonly playerService: PlayerService,
    public readonly device: DeviceService,
    private readonly checkHtml5Service: CheckHtml5Service,
    public readonly router: Router,
    private readonly userService: UserService,
    private readonly eventTracker: EventTrackerService,
    private readonly goftinoService: GoftinoService,
  ) {
  }

  ngAfterViewInit(): void {
    const unread = this.goftinoService.getUnreadCount();
    if (unread && unread > 0) {
      this.countGoftinoEl.nativeElement.style.display = 'flex';
    } else {
      this.countGoftinoEl.nativeElement.style.display = 'none';
    }
    this.countGoftinoEl.nativeElement.innerText = unread.toString();
  }

  public ngOnInit() {
    this.checkSupportHtml();
    this.tokenService.isLogin$.subscribe(c => {
      this.isLogin = c;
      this.subscriptionStatus = null;
      if (c) {
        this.indicator.hide();
        this.subscriptionService
          .checkUserSubscriptionStatus()
          .subscribe((c: SubscriptionStatus | null) => {
            if (c === null) {
              this.subscriptionStatus = SubscriptionStatusEnum.Not_YET_SUBSCRIPTION;
            } else if (c.isUnlimitedSubscription === true) {
              this.subscriptionStatus = SubscriptionStatusEnum.NEW_SUBSCRIPTION;
              this.remainingTimeSubscription = c.totalDaysToExpiration;
            } else if (c.isUnlimitedSubscription === false) {
              if (c.totalDaysToExpiration > 0) {
                this.subscriptionStatus = SubscriptionStatusEnum.OLD_SUBSCRIPTION;
                this.remainingTimeSubscription = c.totalDaysToExpiration;
              } else
                this.subscriptionStatus = SubscriptionStatusEnum.SUBSCRIPTION_EXPIRED;
            }
          });
      } else {
        this.subscriptionStatus = SubscriptionStatusEnum.NOT_LOGIN;
      }
      this.userService.userInfo$.subscribe(z => {
        this.userName = this.userId = '';
        if (z) {
          this.userName = z?.username;
          this.mobileNo = z?.mobileNo;
        }
      })
    });
    this.visibilityCreditCode();
    this.indicator.hide();
    this.appVersion = this.device.getAppVersion(false);
    this.showAboutMenu = (this.parametersService.clientId !== ClientTypeEnum.iGap);

  }

  checkSupportHtml() {
    this.supportVideo = this.checkHtml5Service.supports_video();
    this.supportsCanvas = this.checkHtml5Service.supports_canvas();
    if (!this.supportVideo) {
      this.showIcon = false;
    }
    if (!this.supportsCanvas) {
      this.showIcon = false;
    }
  }

  public visibilityCreditCode() {
    this.showCreditCode = (this.parametersService.clientId !== ClientTypeEnum.CafeBazaar && this.parametersService.clientId !== ClientTypeEnum.Myket);
  }

  public goToSubscription() {
    if (!this.supportsCanvas || !this.supportVideo) {
      this.indicator.show(true);
      this.goToWeb("subscription");
    } else {
      this.indicator.show();
      this.router.navigate(['../subscription', 'plans']).then();
    }
  }

  public logEvent(name, btn_id) {
    this.eventTrack({
      item_name: 'x_btn_tap',
      x_button_id: name,
      x_button_caption: btn_id,
      x_user_is_login: this.isLogin
    });
  }

  public openSettings() {
    this.eventTracker.logEvent("x_btn_tap", {
      location_screen: "profile",
      x_button_id: "settings",
      x_button_caption: "تنظیمات",
    });

    if (this.device.isAndroid()) {
      (window as any).Android.goToSettings();
    } else if (this.device.isIOS()) {
      (window as any).webkit.messageHandlers.callbackHandler.postMessage(
        "settings"
      );
    }
  }

  public setScore() {
    this.device.showDialogRatoToApp();
    // const ref = this.dialog.open(DialogScoreComponent, {});
    // ref.afterClosed.subscribe((result) => {
    //   console.log("Dialog closed", result);
    // });
  }

  public clickNavProfile(name) {
    if (this.supportsCanvas || this.supportVideo) {
      switch (name) {
        case "about":
          this.indicator.show();
          this.router.navigate(["./about"]);
          break;
        case "feedback":
          this.indicator.show(), this.router.navigate(["./feedback"]);
          break;
        case "profile-edit":
          this.indicator.show();
          this.router.navigate(["./profile/profile-edit"]);
          break;
        case "credit":
          this.indicator.show();
          this.router.navigate(["./credit"]);
          break;
        case "redeem":
          this.indicator.show();
          this.router.navigate(["./redeem"]);
          break;
        case "wishlist":
          this.indicator.show();
          this.router.navigate(["./wishlist"]);
          break;
        case "setScore":
          this.setScore();
      }
    } else if (!this.supportsCanvas || !this.supportVideo) {
      switch (name) {
        case "about":
          this.goToWeb("about");
          break;
        case "feedback":
          this.goToWeb("contact");
          break;
        case "profile-edit":
          this.goToWeb("user?profile");
          break;
        case "credit":
          this.goToWeb("credit");
          break;
        case "redeem":
          this.goToWeb("redeem");
          break;
        case "wishlist":
          this.indicator.show();
          this.router.navigate(["./wishlist"]);
          break;
        case "setScore":
          this.setScore();
      }
    }
  }

  public goToWeb(url) {
    this.indicator.show(true);
    this.device.goToWebWithToken(url);
  }

  public exit() {
    this.eventTrack({
      location_screen: "profile",
      x_button_id: "exit",
      x_button_caption: "خروج از نوار",
    });
    this.playerService.closePlayer();
    this.auth.logout();
  }

  public eventTrack(item) {
    this.eventTracker.logEvent("x_items_profile", item)
  }
}
